import { Fragment, h, render } from 'preact'
import Routes from './core/Router'

import './styles/index.css'

// add a switch to DE
const App = () => {
    return (
        <Fragment>
            <Routes />
        </Fragment>
    )
}

render(<App />, document.getElementById('root'))
